import * as angular from 'angular';
import {IController} from "angular";
import {TaskApprovalStatusType} from "../../types/taskApprovalStatus.type";

export class TaskApprovalStatusMultiSelectComponent implements IController {
  approvalStatuses: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  constructor(private $mdSelect) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(TaskApprovalStatusType));
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onReset() {
    this.onChange({approvalStatuses: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({approvalStatuses: this.approvalStatuses});
    this.$mdSelect.hide();
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskApprovalStatusMultiSelect', {
    bindings: {
      approvalStatuses: '<',
      noUnderline: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./task-approval-status-multi-select.html').default,
    controller: TaskApprovalStatusMultiSelectComponent
  });
